var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "list" } }, [
    _c("h2", [_vm._v("アップロードリスト")]),
    _vm._v(" "),
    _c("p", [
      _vm._v("ログインすることでアップロードしたファイルが表示されます。")
    ]),
    _vm._v(" "),
    _c("hr"),
    _vm._v(" "),
    _c(
      "div",
      _vm._l(this.files, function(files, fi) {
        return _c(
          "div",
          { key: fi, staticClass: "tile is-ancestor" },
          _vm._l(files, function(file, si) {
            return _c("div", { key: si, staticClass: "gallery" }, [
              si === 0
                ? _c("div", { staticClass: "tile is-parent" }, [
                    _c("article", { staticClass: "tile is-child box" }, [
                      _c("p", { staticClass: "title" }, [
                        _vm._v("アップロード名：" + _vm._s(file.file_name))
                      ]),
                      _vm._v(" "),
                      _c("p", { staticClass: "title" }, [
                        _vm._v(
                          "オリジナル名：" + _vm._s(file.original_file_name)
                        )
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "content" },
                        [
                          _c(
                            "router-link",
                            {
                              attrs: {
                                to: {
                                  name: "Show",
                                  params: { file_name: file.file_name }
                                }
                              }
                            },
                            [
                              _c("img", {
                                directives: [
                                  {
                                    name: "lazy",
                                    rawName: "v-lazy",
                                    value:
                                      "https://files-uploader.xzy.pw/upload/" +
                                      file.file_name +
                                      "?show=true",
                                    expression:
                                      "'https://files-uploader.xzy.pw/upload/' + file.file_name + '?show=true'"
                                  }
                                ],
                                staticStyle: { width: "100px" },
                                attrs: { alt: "アップロード" }
                              })
                            ]
                          )
                        ],
                        1
                      )
                    ])
                  ])
                : _vm._e(),
              _vm._v(" "),
              si === 1
                ? _c("div", { staticClass: "tile is-parent" }, [
                    _c("article", { staticClass: "tile is-child box" }, [
                      _c("p", { staticClass: "title" }, [
                        _vm._v("アップロード名：" + _vm._s(file.file_name))
                      ]),
                      _vm._v(" "),
                      _c("p", { staticClass: "title" }, [
                        _vm._v(
                          "オリジナル名：" + _vm._s(file.original_file_name)
                        )
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "content" },
                        [
                          _c(
                            "router-link",
                            {
                              attrs: {
                                to: {
                                  name: "Show",
                                  params: { file_name: file.file_name }
                                }
                              }
                            },
                            [
                              _c("img", {
                                directives: [
                                  {
                                    name: "lazy",
                                    rawName: "v-lazy",
                                    value:
                                      "https://files-uploader.xzy.pw/upload/" +
                                      file.file_name +
                                      "?show=true",
                                    expression:
                                      "'https://files-uploader.xzy.pw/upload/' + file.file_name + '?show=true'"
                                  }
                                ],
                                staticStyle: { width: "100px" },
                                attrs: { alt: "アップロード" }
                              })
                            ]
                          )
                        ],
                        1
                      )
                    ])
                  ])
                : _vm._e(),
              _vm._v(" "),
              si === 2
                ? _c("div", { staticClass: "tile is-parent" }, [
                    _c("article", { staticClass: "tile is-child box" }, [
                      _c("p", { staticClass: "title" }, [
                        _vm._v("アップロード名：" + _vm._s(file.file_name))
                      ]),
                      _vm._v(" "),
                      _c("p", { staticClass: "title" }, [
                        _vm._v(
                          "オリジナル名：" + _vm._s(file.original_file_name)
                        )
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "content" },
                        [
                          _c(
                            "router-link",
                            {
                              attrs: {
                                to: {
                                  name: "Show",
                                  params: { file_name: file.file_name }
                                }
                              }
                            },
                            [
                              _c("img", {
                                directives: [
                                  {
                                    name: "lazy",
                                    rawName: "v-lazy",
                                    value:
                                      "https://files-uploader.xzy.pw/upload/" +
                                      file.file_name +
                                      "?show=true",
                                    expression:
                                      "'https://files-uploader.xzy.pw/upload/' + file.file_name + '?show=true'"
                                  }
                                ],
                                staticStyle: { width: "100px" },
                                attrs: { alt: "アップロード" }
                              })
                            ]
                          )
                        ],
                        1
                      )
                    ])
                  ])
                : _vm._e()
            ])
          }),
          0
        )
      }),
      0
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-264bddce", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-264bddce","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/List.vue
// module id = null
// module chunks = 